/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Transcript_DescInputs */



/**
* | output |
* | --- |
* | "Plain text TXT, DOCX, CSV" |
*
* @param {File_Export_Transcript_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_transcript_desc = /** @type {((inputs?: File_Export_Transcript_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Transcript_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte brut TXT, DOCX, CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("Klartext (TXT, DOCX, CSV)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo normale TXT, DOCX, CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обычный текст TXT, DOCX, CSV")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto sin formato TXT, DOCX, CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("纯文本 TXT、DOCX、CSV")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレーンテキスト TXT、DOCX、CSV")
	if (locale === "hi") return /** @type {LocalizedString} */ ("साधारण टेक्स्ट TXT, DOCX, CSV")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto simples TXT, DOCX, CSV")
	return /** @type {LocalizedString} */ ("Plain text TXT, DOCX, CSV")
});